import { Component } from 'react'
import ConnectButton from '../../components/ConnectButton'
import { saveMadKuduApiKey } from 'app/modules/integrations/api'
import withNotifications from 'components/shared/notifications'
import ConditionalRender from 'components/shared/ConditionalRender'
import DisconnectConfirmModal from '../../components/DisconnectConfirmModal'
import PropTypes from 'prop-types'
import './style'

const SUCCESS_MESSAGE = 'MadKudu was successfully connected!'
const ERROR_MESSAGE = 'Oops, there was an error. Please try again.'

class MadKudu extends Component {

  static contextTypes = {
    app: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      apiKey: '',
      isConnecting: false,
      isConnected: props.isConnected,
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ isConnected: props.isConnected })
  }

  onApiKeyChanged = (event) => {
    this.setState({ apiKey: event.target.value })
  }

  isApiKeyValid = () => {
    return this.state.apiKey !== ''
  }

  isConnectButtonDisabled = () => {
    return !this.isApiKeyValid()
  }

  connectIntegration = () => {
    const { notifications } = this.props
    const { IntegrationsQueries } = this.context.app.queries

    const connect = () => {
      saveMadKuduApiKey(this.state.apiKey)
        .then(() => notifications.success(SUCCESS_MESSAGE))
        .catch(() => notifications.error(ERROR_MESSAGE))
        .then(() => this.setState({ isConnecting: false, isConnected: true }))
        .then(() => IntegrationsQueries.fetchIntegrationStates())
    }

    this.setState({ isConnecting: true }, connect)
  }

  render() {
    const { isConnecting, isConnected, showDisconnectModal } = this.state

    return (
      <div className="madkudu-integration-page">
        <p className="integration-page-description">
          Want to one-up your lead scoring in Drift?
          The MadKudu integration will use their standard model to score your leads so you can proactively target your best leads and know more about who you are talking to.
        </p>
        <p className="integration-page-description">
          If you are already a MadKudu customer, you can put in your API key and we will apply your MadKudu model for lead scoring, which will appear on the contact in the conversation view!
          <a href="https://help.drift.com/integrations/madkudu-integration" target="_blank">
            Learn More
          </a>
        </p>
        <div className="drift-form">
          <ConditionalRender condition={!isConnected}>
            <span className="madkudu-key-label">
              API key
            </span>
            <input
              className="madkudu-key-input"
              type="text"
              placeholder="e.g. 123456"
              onChange={this.onApiKeyChanged}
            />
            <p className="madkudu-key-description">
              Use your MadKudu API Key to connect MadKudu and Drift
            </p>
          </ConditionalRender>
        </div>
        <ConditionalRender condition={showDisconnectModal}>
          <DisconnectConfirmModal 
            integrationName="MadKudu" 
            onDisconnect={this.disconnectIntegration}  
            onClose={this.hideDisconnectModal}/>
        </ConditionalRender>
        <ConditionalRender condition={!isConnected}>
          <ConnectButton
            disabled={this.isConnectButtonDisabled()}
            onClick={this.connectIntegration}
            isProcessing={isConnecting}
          />
        </ConditionalRender>
      </div>
    )
  }
}

export default withNotifications(MadKudu)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/MadKudu/index.js